import { X } from 'lucide-react';
import { SidebarContent } from './SidebarContent';
import { useTranslation } from 'react-i18next';

interface SidebarProps {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ sidebarOpen, toggleSidebar }) => {
  const {i18n} = useTranslation();
  return (
    <>
      {/* Mobile Sidebar */}
      <aside
        className={`
          fixed top-0 h-full w-[286px] bg-white p-4 z-20
          ltr:left-0 rtl:right-0 transition-transform
          ${sidebarOpen ? 'translate-x-0' : 'ltr:-translate-x-full rtl:translate-x-full'}
          lg:hidden
          ${i18n.language === 'ar' ? 'shadow-lg shadow-left' : 'shadow-lg shadow-right'}
        `}
      >
        <SidebarContent  />

        {/* Close button */}
        <button
          className="absolute top-4 ltr:right-4 rtl:left-4 text-secondary hover:text-primary"
          onClick={toggleSidebar}
        >
          <X size={28} />
        </button>
      </aside>

      {/* Desktop Sidebar */}
      <aside
      className={`
        hidden lg:block top-0 h-full w-[286px] p-4 z-20 bg-white
        ${i18n.language === 'ar' ? 'shadow-lg shadow-left' : 'shadow-lg shadow-right'}
      `}
    >
      <SidebarContent/>
    </aside>

    </>
  );
};

export default Sidebar;
